/**
 * Developer Registration Domain Types
 * Shared types for developer registration queries and commands
 */

// ============================================================================
// Program Type Constants (mirrors C# RegistrationProgramType enum)
// ============================================================================

export const PROGRAM_TYPE = {
  DEVELOPER: 'developer',
  DEMO: 'demo',
} as const;

export type ProgramType = (typeof PROGRAM_TYPE)[keyof typeof PROGRAM_TYPE];

// ============================================================================
// Request/Response Types
// ============================================================================

/**
 * Form data for developer registration submission
 */
export interface DeveloperRegistrationFormData {
  companyName: string;
  companyAddress: string;
  ownerContactName: string;
  ownerContactEmail: string;
  technicalContactName?: string;
  technicalContactEmail?: string;
  accessCode?: string;
  programType?: ProgramType;
}

/**
 * Response from registration submission
 */
export interface SubmitDeveloperRegistrationResponse {
  success: boolean;
  stripeUrl?: string;
  redirectUrl?: string;
  errorMessage?: string;
  validationErrors?: Record<string, string[]>;
}

/**
 * Request for access code validation
 */
export interface ValidateAccessCodeRequest {
  accessCode: string;
}

/**
 * Response from access code validation
 */
export interface ValidateAccessCodeResponse {
  isValid: boolean;
  accessCodeType: string;
  salespersonEmail: string | null;
  errorMessage?: string;
}
